import { render, staticRenderFns } from "./HomeTest.vue?vue&type=template&id=28fbdcfa"
import script from "./HomeTest.vue?vue&type=script&lang=js"
export * from "./HomeTest.vue?vue&type=script&lang=js"
import style0 from "./HomeTest.vue?vue&type=style&index=0&id=28fbdcfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports